import { sendCustomError } from "@otto-ec/global-resources/apm";
import { createLogger } from "utils/logging";
import type { QBus } from "@otto-ec/global-resources/event-q-bus";
import { benefitBounce } from "@otto-ec/nexus-registry/benefit/bounce";

const attributeNameVariationId = "variation-id";

const log = createLogger("tag", "bounce.component");

export class BounceElement extends HTMLElement {
	static observedAttributes = [attributeNameVariationId];
	private readonly eventQBus: QBus;

	constructor() {
		super(); /*                                     */
		this.eventQBus = window.o_global.eventQBus;
	}

	private _isConnected = false;

	override get isConnected() {
		return this._isConnected;
	}

	override set isConnected(value: boolean) {
		this._isConnected = value;
	}

	async attributeChangedCallback(name: string, oldValue: string, newValue: string) {
		log.info("Attribute update: ", name, oldValue, newValue, this.isConnected);
		if (this.isConnected) {
			this.firstElementChild?.remove();
			await this.callBackend();
		}
	}

	async connectedCallback() {
		this.isConnected = true;
		await this.callBackend();
	}

	async callBackend() {
		const urlSearchParams = this.getSearchParams();

		log.info("Calling bounce with %s", JSON.stringify(urlSearchParams));

		let tries = 0;
		let success = false;
		const status_code = [];

		while (tries++ < 3 && !success) {
			let response: Response;
			try {
				response = await fetch(`/benefit-tag/bounce?${urlSearchParams}`, {
					headers: {
						Accept: "text/html;charset=UTF-8",
						"X-Requested-With": "XMLHttpRequest",
					},
				});
			} catch (error) {
				log.warn("tag bounce request returns an error!", error);

				if (error instanceof DOMException) {
					status_code.push(error.name);
				} else {
					status_code.push(error);
				}
				continue;
			}

			status_code.push(response.status);
			success = response.ok;

			if (success) {
				/*                          */
				const text = await response.text();

				this.innerHTML = text;
				benefitBounce.init.emit({});

				break;
			}
			log.warn("tag endpoint returns a non ok response!", response.status);
		}

		if (!success) {
			sendCustomError("ft9-benefit-tag-bounce-not-ok", "callBackend error", {
				urlSearchParams: urlSearchParams.toString(),
				status_code: status_code.join(":"),
				tries: tries - 1,
			});
		}
	}

	private getSearchParams() {
		const urlSearchParams = new URLSearchParams();

		function addToSearchParam(parmName: string, value: string | null) {
			if (value != null) {
				urlSearchParams.append(parmName, value);
			}
		}

		addToSearchParam("variationId", this.getAttribute(attributeNameVariationId));
		return urlSearchParams;
	}
}

customElements.define("ft9-bounce-v1", BounceElement);
